module.exports = __webpack_public_path__ + "static/media/ig-fail.1fca0184.svg";